import React, { Component } from 'react';
import PropTypes from 'prop-types';
import result from 'lodash/result';

import { Location } from 'models/locations';
import Quote from 'models/quote';

import About from 'components/search/list/location-detail/about';
import LocationRating from 'components/common/location-rating';

const propTypes = {
  location: PropTypes.instanceOf(Location).isRequired,
  quote: PropTypes.instanceOf(Quote),
};

const defaultProps = {
  quote: null,
};

export class LocationDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.toggleDetails = this.toggleDetails.bind(this);
  }

  toggleDetails(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { location, quote } = this.props;
    const { expanded } = this.state;

    return (
      <div className="margin-horizontal-15">
        <hr className="ticket-dash" />
        <div className="margin-top-20 margin-bottom-30">
          <About location={location} quote={quote} expanded={expanded} truncationLimit={120} />
        </div>
        <div className="margin-vertical-30">
          <LocationRating rating={result(location, 'hasRatings', false) ? location.ratingSummary.averageRating.toFixed(1) : null} visible={expanded} />
        </div>
        <div
          onClick={this.toggleDetails}
          className="text-center text-color-blue text-color-hover-blue text-size-12 text-weight-book clickable margin-vertical-30"
        >
          { expanded ? 'LESS' : 'MORE' } ABOUT THIS FACILITY
          <span className={`display-inline-block vertical-align-top margin-left-10 padding-top-3 text-size-8 iconified-font iconified-chevron-${expanded ? 'up' : 'down'}`} />
        </div>
      </div>
    );
  }
}

LocationDetails.propTypes = propTypes;
LocationDetails.defaultProps = defaultProps;

export default LocationDetails;
